module.exports = __webpack_public_path__ + "h5/img/start.6bccf29b.png";